import React, { useRef, useState } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import EditFreebetFR, { EditFreebetRef } from "./EditFreebetFR"
import { Freebet, FreebetUpdate } from "./FreebetModels"

interface EditFreebetDialogProps {
    freebetId: number
    open: boolean
    onClose: (changedItem?: Freebet) => void
}

const handleClose = (props:EditFreebetDialogProps, changedItem?: Freebet) => {
    props.onClose(changedItem);
}

const EditFreebetDialog: React.FC<EditFreebetDialogProps> = (props) => {
    const ref = useRef<EditFreebetRef>(null);
    const [changedItem, setChangedItem] = useState<Freebet | undefined>(undefined);
    const [editItem, setEditItem] = useState<FreebetUpdate | undefined>(undefined);
    const [message, setMessage] = useState<string | undefined>(undefined);
    const onChange = (changedItem?: Freebet) => {
        // if (changedItem) {
        //     AgentUtil.fixSyndicateOverview(changedItem);
        // }
        setChangedItem(changedItem);
        setEditItem(undefined);
    }
    const onEdit = (editItem?: FreebetUpdate) => {
        setEditItem(editItem);
    }
    const onMessage = (msg?: string) => {
        var msg1 = msg;
        if (msg1 && msg1.length > 30) {
            msg1 = msg1.substring(0, 26) + "...";
        } 
        if (msg1 !== message) {
            setMessage(msg1);
        }
    }
    const onSave = () => {
        if (!editItem) {
            return;
        }
        ref.current?.save();
    }
    return (
        <Dialog open={props.open} maxWidth="lg">
            <DialogTitle id="form-dialog-title">Freebet</DialogTitle>
            <DialogContent dividers>
                <EditFreebetFR ref={ref} freebetId={props.freebetId} onChange={onChange} onEdit={onEdit} saveButtonVisible={false} onMessage={onMessage} />
            </DialogContent>
            <DialogActions>
                {message && message.length > 0 ? (<span style={{marginRight: "5px"}}>{message}</span>) : null}
                <Button onClick={() => onSave()} color="primary" disabled={!editItem} >
                    Save
                </Button>
                <Button onClick={() => handleClose(props, changedItem)} color="primary" >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditFreebetDialog;
